import React, {useEffect, useState} from 'react';

function CustomLegend({ data }) {
    const legendStyle = {
        display: 'flex',
        alignItems: 'center', // Center vertically
        justifyContent: 'center', // Center horizontally
    };

    const [marginTop, setMarginTop]= useState('40px');
    const [marginLeft, setMarginLeft]= useState('0px');

    const resize = () => {
        if (window.innerWidth >= 900 && window.innerWidth <= 1252) {
            setMarginTop('20px');
            setMarginLeft('5px');
        }
        else if(window.innerWidth >= 1253) {
            setMarginTop('40px');
        }
        else if(window.innerWidth >= 604 && window.innerWidth <= 700) {
            setMarginTop('10px');
        }
        else if(window.innerWidth >= 701 && window.innerWidth <= 700) {
            setMarginTop('20px');
        }
    }


    useEffect(() => {
        const handleResize = () => {
            resize();
        }
        window.addEventListener('resize', handleResize);
    },[]);
    return (
        <div style={legendStyle}>
            {data.map((item) => (
                <div key={item.label} style={{ marginRight: '15px', marginTop: marginTop, marginLeft: marginLeft }}>
          <span
              style={{
                  backgroundColor: item.color,
                  width: '16px',
                  height: '16px',
                  display: 'inline-block',
                  marginRight: '6px',
              }}
          ></span>
                    {item.label}
                </div>
            ))}
        </div>
    );
}

export default CustomLegend;